import { useQuery } from "@tanstack/react-query";
import {
  type GetContextsResponse,
  getAuthContexts,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const CONTEXTS_QUERY_KEY = "AUTH_CONTEXTS";

export const contextsKeys = {
  all: [CONTEXTS_QUERY_KEY],
};

/**
 * Lists all available role/membership contexts for the currently authenticated Identity,
 * plus the PublicID of the active one. Used by the top-nav context switcher.
 */
export const useGetContextsQuery = (enabled = true) =>
  useQuery<GetContextsResponse>({
    queryKey: contextsKeys.all,
    queryFn: processResponseWithApiProblemDetails(() => getAuthContexts()),
    enabled,
    staleTime: MS_TIME.minute,
  });
